import axios from 'axios';
import getHeaderToken from './getHeaderToken';

const getContractPeriod = async (officeNo) => {
    try {

      const header = await getHeaderToken();
      const apiUrl = `${process.env.REACT_APP_CONTRACT_PERIOD_API}?office_number=${officeNo}`;
      const response = await axios.get(apiUrl, header);
      return response.data;
    } catch (error) {
      return 0; // デフォルト値
    }
};

export default getContractPeriod;